/**
 * BooleanCell Component
 * 
 * Renders boolean values as colored pills:
 * - Green pill for true
 * - Red pill for false
 * - Italic text for null/undefined
 */

import { CellRendererProps } from '../../../../../types/AppPanel';

export default function BooleanCell({ 
  value 
}: CellRendererProps<boolean | null | undefined>) {
  // Handle null/undefined
  if (value === null) {
    return <span className="text-white/30 italic">(null)</span>;
  }
  if (value === undefined) {
    return <span className="text-white/30 italic">(undefined)</span>;
  }

  const isTrue = Boolean(value);

  return (
    <span
      className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${
        isTrue
          ? 'bg-emerald-500/20 text-emerald-400'
          : 'bg-red-500/20 text-red-400'
      }`}
    >
      {isTrue ? 'true' : 'false'}
    </span>
  );
}

